import { Dispatch } from '@reduxjs/toolkit'

import { getFilesForMe } from '@/helpers/api-ts/files'
import { getUserPayslips } from '@/helpers/api-ts/payslip'
import { createLatestRunGuard } from '@/helpers/createLatestRunGuard'
import { getErrorResponse } from '@/helpers/getErrorResponse'
import {
    DOCUMENTS_FAILURE,
    DOCUMENTS_GET_DOCUMENTS_FOR_ME_SUCCESS,
    DOCUMENTS_REQUEST,
    SET_LOADING,
} from '@/redux/actionTypes'

const startDocumentsRun = createLatestRunGuard()

export const getDocumentsForMe = (year: number, user: { loketEmployeeId: string | null }) => async (dispatch: Dispatch): Promise<void> => {
    const isLatestRun = startDocumentsRun()

    dispatch({ type: SET_LOADING, loading: true })
    dispatch({ type: DOCUMENTS_REQUEST })

    try {
        const includes = ['documentType', 'linkedUser']
        const files = await getFilesForMe(year, includes)

        const { loketEmployeeId } = user
        const payslips = loketEmployeeId ? await getUserPayslips(loketEmployeeId, year) : []

        if (! isLatestRun()) return

        dispatch({
            type: DOCUMENTS_GET_DOCUMENTS_FOR_ME_SUCCESS,
            documents: [...files, ...payslips],
        })
    } catch (error) {
        if (! isLatestRun()) return

        dispatch({ type: DOCUMENTS_FAILURE, errors: [getErrorResponse(error)] })
    }

    dispatch({ type: SET_LOADING, loading: false })
}
